import React from 'react';

const ActionText = () => {
    return <div>
        
    </div>
}

export default ActionText;